'use client';

import * as React from 'react';

import { cn } from '@/lib/utils';

import IconYoutubePlayButton from '~/svg/IconYoutubePlayButton.svg';

export type VideoProps = {
  classNames?: {
    container?: string;
    video?: string;
  };
  url: string;
};

const borderStyles = 'rounded border border-gray-200 dark:border-gray-300';

export function Video(props: VideoProps) {
  if (props.url.includes('youtube.com')) {
    return <VideoYoutube {...props} />;
  }

  return <VideoIframe {...props} />;
}

export function VideoIframe({ url, classNames }: VideoProps) {
  return (
    <div
      className={cn(
        'relative m-0 flex w-full overflow-hidden',
        classNames?.container
      )}
    >
      <iframe
        src={url}
        loading='lazy'
        allowFullScreen
        width='100%'
        className={cn('aspect-video', borderStyles, classNames?.video)}
      />
    </div>
  );
}

export function VideoYoutube({ url, classNames }: VideoProps) {
  const [showVideo, setShowVideo] = React.useState(false);

  function handleClick() {
    setShowVideo(true);
  }

  function getVideoId(url: string) {
    // https://stackoverflow.com/questions/3452546/how-do-i-get-the-youtube-video-id-from-a-url
    const regExp =
      /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
    const match = url.match(regExp);
    return match && match[7].length == 11 ? match[7] : false;
  }
  const embedID = getVideoId(url);

  return (
    <div
      className='flex w-full items-center justify-center rounded'
      data-tracker-component='video-popup'
    >
      <div
        onClick={handleClick}
        className={cn(
          'relative flex aspect-video h-full w-full cursor-pointer items-center justify-center bg-cover bg-center',
          borderStyles,
          classNames?.container
        )}
        tabIndex={1}
        style={{
          backgroundImage: `url("https://i.ytimg.com/vi_webp/${embedID}/sddefault.webp")`,
        }}
      >
        {!showVideo ? (
          <IconYoutubePlayButton className='absolute z-10 h-20 w-20' />
        ) : (
          <iframe
            allowFullScreen
            src={`https://www.youtube.com/embed/${embedID}?rel=0&showinfo=0&autoplay=1`}
            width='100%'
            className={cn('aspect-video rounded ', classNames?.video)}
            title='youtube video'
          />
        )}
      </div>
    </div>
  );
}
